<template>
  <a-layout>
    <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>click(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
      <vxe-column :formatter="({row})=>getStrings(row.logicalStores,'name')" field="logicalStores" title="business.label.logicalStore"/>
      <vxe-column :formatter="({row})=>getStrings(row.itemCategories,'name')" field="itemCategories" title="business.label.itemCategory"/>
    </vxe-table>
  </a-layout>
</template>

<script>
import { findAll } from '@/api/Api'
import { getStrings } from '@/utils/util'

export default {
  name: 'MaintenanceConfigTable',
  data() {
    return {
      loading: false,
      data: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getStrings,
    getData() {
      this.loading = true
      findAll('maintenanceConfigFactory').then(res => {
        if (res.success) {
          this.data = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    click(row) {
      this.$emit('click', row)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>